// Stato di attivazione di tutte le funzionalità dell'explorer (tutte attive per default).
export const DEFAULT_FEATURES = {
  nameFilter: true,
  formatFilter: true,
  fullText: true,
  orgFilter: true,
  map: true,
  copy: true,
  sort: true,
  preview: true,
};
